exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".processReviewBox {\n  width: 100%;\n  min-height: 100vh;\n  background-color: #F4F4F5;\n  padding-bottom: 0.8rem;\n  overflow: hidden;\n}\n.processReviewBox .headerBox {\n  padding: 0 0.12rem;\n  background-color: #10C2B0;\n  color: #fff;\n}\n.processReviewBox .headerBox h2 {\n  margin: 0;\n  font-size: 0.18rem;\n  padding: 0.16rem 0;\n  -webkit-box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.4);\n          box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.4);\n}\n.processReviewBox .headerBox p {\n  margin: 0;\n  font-size: 0.14rem;\n  line-height: 0.18rem;\n  padding: 0.16rem 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/processReview/index.less
// module id = 1087
// module chunks = 0